import { configureStore } from '@reduxjs/toolkit';
import loaderSlice from './loaderSlice';
import noticeSlice from './noticeSlice';
import photoGallerySlice from './photoGallerySlice';
import videoGallerySlice from './videoGallerySlice';

const store = configureStore({
  reducer: {
    loader: loaderSlice.reducer,
    notices: noticeSlice.reducer,
    photoGallery: photoGallerySlice.reducer,
    videoGallery: videoGallerySlice.reducer,
  },
});

export default store;
